import { Injectable } from '@angular/core';
import { GeneralService } from './general.service';
import { environment } from 'src/environments/environment';
import { MsgService } from '../local/msg.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GeneralInfo } from '../../models/entity/genaralInfo.model';

@Injectable({
  providedIn: 'root'
})
export class GeneralInfoService extends GeneralService {

  constructor(
    protected messageService: MsgService,
    protected httpClient: HttpClient,
  ) {
    super(messageService, httpClient, environment.apiUrl, 'GeneralInfo');
  }

  public async getGeneralInfo(): Promise<GeneralInfo> {
    const param = new HttpParams();
    const res = await this.getCustomApi('Get', param);
    if (this.isValidResponse(res)) {
      return res.data;
    }
    return new GeneralInfo();
  }
}
